/**
 * ShadCN UI Utility Functions
 *
 * Utility functions for ShadCN UI components, including className merging.
 * Uses clsx and tailwind-merge for optimal class name handling.
 */

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
